// ----------------------------------------------------------------------

const account = {
  displayName: 'Harsha',
  role:"Administrator",
  email: 'harsha@mail.com',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
